import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {TextField, Button, InputAdornment, IconButton} from "@mui/material";
import FlexBetween from "./FlexBetween";
import { session } from "../services/session";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { loginValidationSchema as validationSchema } from "../schemas/login";
import { projectType } from "../services/project-type";
import { useProjectTypeContext } from "./ProjectTypeProvider";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAuth } from "./AuthProvider";


export function Login() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [loginStatus, setLoginStatus] = useState(false);
    const {updateProjectType} = useProjectTypeContext();
    const [showPassword, setShowPassword] = useState(false);
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        setLoginStatus(isAuthenticated);
    }, []);

    useEffect(() => {
        if (loginStatus) {
            navigate("dash/companies");
        }
    }, [loginStatus, navigate]);

    const passwordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {
            //LOGIN
            try {
                await session.getAccessToken(values);
            } catch (error) {
                console.error(error);
                enqueueSnackbar("Usuario o contraseña incorrectos", {
                    preventDuplicate: true,
                    variant: "error",
                });
                // si falla no sigo
                return;
            }
            //LECTURA DE MICROSERVICIO CONTENEDOR
            try {
                updateProjectType(await projectType.getProjectType());
            } catch (error) {
                enqueueSnackbar("No se pudo obtener el tipo de Microservicio", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
            navigate("dash/companies");
        },
    });

    return (
        <FlexBetween>
            <form onSubmit={formik.handleSubmit}>
                <TextField
                    fullWidth
                    id="email"
                    name="email"
                    label="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    sx={{ m: "10px" }}
                />
                <TextField
                    fullWidth
                    id="password"
                    name="password"
                    label="Contraseña"
                    type={showPassword ? 'text' : 'password'}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                    }
                    helperText={
                        formik.touched.password && formik.errors.password
                    }
                    sx={{ m: "10px" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={passwordVisibility}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    color="primary"
                    variant="contained"
                    fullWidth
                    type="submit"
                    sx={{ m: "10px" }}>
                    Iniciar sesión
                </Button>
            </form>
        </FlexBetween>
    );
}

export default Login;
